import { render, staticRenderFns } from "./EditCursusPostBac.vue?vue&type=template&id=5e93403a"
import script from "./EditCursusPostBac.vue?vue&type=script&lang=js"
export * from "./EditCursusPostBac.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports